// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var FormV5 = require("../../uikit/reason/atoms/Form/FormV5.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Formality = require("../../vendor/re-formality/Formality.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
var Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
var RichTextEditorV5 = require("../common/Components/RichTextEditorV5.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var ProfilePageBiographyInformationForm_agent_graphql = require("../../__generated__/ProfilePageBiographyInformationForm_agent_graphql.bs.js");
var ProfilePageBiographyInformationForm_UpdateAgentProfileBiographyMutation_graphql = require("../../__generated__/ProfilePageBiographyInformationForm_UpdateAgentProfileBiographyMutation_graphql.bs.js");

var validators = {
  biography: {
    strategy: "OnFirstSuccessOrFirstBlur",
    validate: (function (param) {
        return {
                TAG: "Ok",
                _0: param.biography
              };
      })
  }
};

function initialFieldsStatuses(_input) {
  return {
          biography: "Pristine"
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            biography: "Pristine"
          },
          collectionsStatuses: undefined,
          formStatus: "Editing",
          submissionStatus: "NeverSubmitted"
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.biography;
  var match$1;
  match$1 = typeof match !== "object" ? validators.biography.validate(input) : match._0;
  if (match$1.TAG === "Ok") {
    return {
            TAG: "Valid",
            output: {
              biography: match$1._0
            },
            fieldsStatuses: {
              biography: {
                TAG: "Dirty",
                _0: match$1,
                _1: "Shown"
              }
            },
            collectionsStatuses: undefined
          };
  } else {
    return {
            TAG: "Invalid",
            fieldsStatuses: {
              biography: {
                TAG: "Dirty",
                _0: match$1,
                _1: "Shown"
              }
            },
            collectionsStatuses: undefined
          };
  }
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action !== "object") {
            switch (action) {
              case "BlurBiographyField" :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.biography, validators.biography, (function (status) {
                          return {
                                  biography: status
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "Submit" :
                  var match = state.formStatus;
                  if (typeof match === "object" && match.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== "Valid") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: "AttemptedToSubmit"
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
                  return {
                          TAG: "UpdateWithSideEffects",
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: "Submitting",
                              _0: tmp
                            },
                            submissionStatus: "AttemptedToSubmit"
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              onSubmit(output, {
                                    notifyOnSuccess: (function (input) {
                                        dispatch({
                                              TAG: "SetSubmittedStatus",
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        dispatch({
                                              TAG: "SetSubmissionFailedStatus",
                                              _0: error
                                            });
                                      }),
                                    reset: (function () {
                                        dispatch("Reset");
                                      }),
                                    dismissSubmissionResult: (function () {
                                        dispatch("DismissSubmissionResult");
                                      })
                                  });
                            })
                        };
                  break;
              case "DismissSubmissionError" :
                  var match$2 = state.formStatus;
                  if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "DismissSubmissionResult" :
                  var match$3 = state.formStatus;
                  if (typeof match$3 !== "object") {
                    if (match$3 === "Editing") {
                      return "NoUpdate";
                    }
                    
                  } else if (match$3.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: "Editing",
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "Reset" :
                  return {
                          TAG: "Update",
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG) {
              case "UpdateBiographyField" :
                  var nextInput = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.biography, state.submissionStatus, validators.biography, (function (status) {
                                    return {
                                            biography: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "SetSubmittedStatus" :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                biography: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                biography: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmissionFailedStatus" :
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: "SubmissionFailed",
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "MapSubmissionError" :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 !== "object") {
                    return "NoUpdate";
                  }
                  if (error$1.TAG !== "Submitting") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "SubmissionFailed",
                                _0: map(error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "Submitting",
                                _0: map(error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "Submitting" ? false : true;
  return {
          updateBiography: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateBiographyField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          blurBiography: (function () {
              dispatch("BlurBiographyField");
            }),
          biographyResult: Formality.exposeFieldResult(state.fieldsStatuses.biography),
          input: state.input,
          status: state.formStatus,
          dirty: (function () {
              var match = state.fieldsStatuses;
              var tmp = match.biography;
              if (typeof tmp !== "object") {
                return false;
              } else {
                return true;
              }
            }),
          valid: (function () {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === "Valid") {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function () {
              dispatch("Submit");
            }),
          dismissSubmissionError: (function () {
              dispatch("DismissSubmissionError");
            }),
          dismissSubmissionResult: (function () {
              dispatch("DismissSubmissionResult");
            }),
          mapSubmissionError: (function (map) {
              dispatch({
                    TAG: "MapSubmissionError",
                    _0: map
                  });
            }),
          reset: (function () {
              dispatch("Reset");
            })
        };
}

var FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var convertVariables = ProfilePageBiographyInformationForm_UpdateAgentProfileBiographyMutation_graphql.Internal.convertVariables;

var convertResponse = ProfilePageBiographyInformationForm_UpdateAgentProfileBiographyMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = ProfilePageBiographyInformationForm_UpdateAgentProfileBiographyMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, ProfilePageBiographyInformationForm_UpdateAgentProfileBiographyMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, ProfilePageBiographyInformationForm_UpdateAgentProfileBiographyMutation_graphql.node, convertResponse, convertWrapRawResponse);

var UpdateAgentProfileBiographyMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

var convertFragment = ProfilePageBiographyInformationForm_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ProfilePageBiographyInformationForm_agent_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ProfilePageBiographyInformationForm_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ProfilePageBiographyInformationForm_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ProfilePageBiographyInformationForm_agent_graphql.node, convertFragment, fRef);
}

var AgentFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ProfilePageBiographyInformationForm(props) {
  var agent = use$1(props.agent);
  var match = use();
  var updateBiography = match[0];
  var form = useForm({
        biography: agent.biography
      }, (function (param, param$1) {
          var notifyOnFailure = param$1.notifyOnFailure;
          var notifyOnSuccess = param$1.notifyOnSuccess;
          updateBiography({
                input: {
                  biography: param.biography
                }
              }, undefined, undefined, undefined, (function (param, param$1) {
                  var updateAgentProfileBiography = param.updateAgentProfileBiography;
                  if (updateAgentProfileBiography !== undefined && updateAgentProfileBiography.__typename === "Agent") {
                    return notifyOnSuccess(undefined);
                  } else {
                    return notifyOnFailure("An error occurred while submitting your data...");
                  }
                }), undefined, undefined);
        }));
  var initialBiography = React.useRef(agent.biography);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        "Biography",
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Form__Components.FormStatusMessageV2.make, {
                                    status: form.status,
                                    submissionErrorToString: (function (v) {
                                        return v;
                                      }),
                                    onSuccessMessage: "Account updated",
                                    resetForm: form.reset,
                                    dismissSubmissionResult: form.dismissSubmissionResult
                                  }),
                              className: "my-4"
                            })
                      ],
                      className: "text-2xl border-b pb-4 font-semibold mb-8"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("p", {
                            children: "Tell other Top Agent Network members about yourself."
                          }),
                      className: "mb-8"
                    }),
                JsxRuntime.jsxs("form", {
                      children: [
                        JsxRuntime.jsx(FormV5.FormGroup.make, {
                              label: "Biography:",
                              wide: true,
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx(RichTextEditorV5.make, {
                                          initialContent: initialBiography.current,
                                          onChange: (function (text) {
                                              form.updateBiography((function (param, biography) {
                                                      return {
                                                              biography: Form__Helpers.noneIfEmpty(biography)
                                                            };
                                                    }), text);
                                            }),
                                          onBlur: (function (param) {
                                              form.blurBiography();
                                            }),
                                          toolbar: "none",
                                          height: "short"
                                        }),
                                    className: "flex flex-col justify-stretch"
                                  })
                            }),
                        JsxRuntime.jsx(FormV5.FormGroup.make, {
                              children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                    onClick: (function (extra) {
                                        return Form__Helpers.preventDefault(form.submit, extra);
                                      }),
                                    disabled: !form.valid() || form.submitting || match[1],
                                    children: "Save"
                                  })
                            })
                      ],
                      onSubmit: (function ($$event) {
                          $$event.preventDefault();
                          form.submit();
                        })
                    })
              ],
              className: "flex flex-col my-8"
            });
}

var make = ProfilePageBiographyInformationForm;

exports.FormConfig = FormConfig;
exports.UpdateAgentProfileBiographyMutation = UpdateAgentProfileBiographyMutation;
exports.AgentFragment = AgentFragment;
exports.make = make;
/* commitMutation Not a pure module */
